import '../../../assets/style/HPC1.css';
import { useTranslation } from "react-i18next";

function HPC1() {
    const { t } = useTranslation();
    
    const listPicture = [{
        src: "/photo/frame1.webp",
    },
    {
        src: "/photo/frame2.webp",
    },
    {
        src: "/photo/frame3.webp",
    },
    {
        src: "/photo/frame4.webp",
    }];

    return(
        <section className='HPC1'>
            <div className='mainHPC1'>
                <img src="/photo/Background.webp" className='goneMobile backgroundHero' alt="background" loading='eager' fetchPriority='high'/>
                <div className='contentMainHPC1 goneMobile'>
                    <h1 className='white'>{t("hpc1title")}</h1>
                    <p className='white' style={{marginBottom: '3%'}}>{t("hpc1text")}</p>
                    <button className='buttonGrey' onClick={() => {window.open('https://wa.me/6281703090603', '_blank')}}>{t("hpc1colaboration")}</button>
                    <div className='previewHPC1'>
                        {listPicture.map((item, index) => (
                            <div key={index} style={{flex: '1'}}>
                                <img src={item.src} className={index === 0 ? 'leftBorder width100' : index === 3 ? 'rightBorder width100' : 'width100'} alt="listdemo"/>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Mobile */}
                <div className='contentMainHPC1Mobile'>
                    <h1 className='white'>{t("hpc1title")}</h1>
                    <p className='white' style={{marginBottom: '6%'}}>{t("hpc1text")}</p>
                    <button className='buttonGrey' onClick={() => {window.open('https://wa.me/6281703090603', '_blank')}}>{t("hpc1colaboration")}</button>
                </div>

            </div>
        </section>
    )
}

export default HPC1;